import { useTranslation } from "react-i18next";

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full py-16 md:py-20 px-4 md:px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20abstract%20background%20with%20flowing%20warm%20beige%20and%20cream%20silk%20fabric%20draped%20organically%2C%20gentle%20folds%20catching%20diffused%20natural%20light%2C%20luxurious%20textile%20texture%2C%20elegant%20and%20clean%2C%20airy%20atmosphere%2C%20minimal%20editorial%20fashion%20backdrop%2C%20soft%20pastel%20warmth&width=1600&height=800&seq=cta-final-v3&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-background-50/65"></div>
      </div>

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-4xl text-foreground-900 mb-6 leading-tight">
          {t("cta.final.title")}
        </h2>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 px-8 py-3.5 rounded-md bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          {t("cta.final.button")}
          <i className="ri-arrow-right-up-line"></i>
        </a>
      </div>
    </section>
  );
}